<template>
  <div>
    <b-jumbotron>
      <b-row>
        <font-awesome-layers full-width class="fa-3x logo">
          <font-awesome-icon icon="square" style="color: #85458a" />
          <font-awesome-icon icon="hospital-user" transform="left-2 shrink-8" style="color: white" />
        </font-awesome-layers>
        <h5>{{ this.name }} Details View</h5>
      </b-row>
    </b-jumbotron>
    <div id="idBranchNav">
      <b-tabs nav-class="details-nav" active-nav-item-class="navActive">
        <b-tab id="idBranchNavUsers" lazy title="Users">
          <AdminAreaBranchDetailTab :branchId="id" type="user" />
        </b-tab>
        <b-tab id="idBranchNavHospitals" lazy title="Hospitals">
          <AdminAreaBranchDetailTab :branchId="id" type="hospital" />
        </b-tab>
        <b-tab id="idBranchNavScanFacilities" lazy title="Scan Facilities">
          <AdminAreaBranchDetailTab :branchId="id" type="scanFacility" />
        </b-tab>
        <b-tab id="idBranchNavSurgeons" lazy title="Surgeons">
          <AdminAreaBranchDetailTab :branchId="id" type="surgeon" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import AdminAreaBranchDetailTab from "@/components/AdminAreaBranchDetailTab.vue";

export default {
  data() {
    return {};
  },
  components: { AdminAreaBranchDetailTab },
  created() {
    const { id, name } = this.$route.query;
    this.id = id;
    this.name = name;
  }
};
</script>

<style scoped>
#idBranchNav {
  margin: 1rem;
}
</style>